export default (element, event, callback, once = true) => {
  element.addEventListener(event, () => callback(), { once });
  Array.from(element.children).forEach((child) => {
    child.addEventListener(event, e => e.stopPropagation(), { once: true });
  });
};
